import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import { Account } from '@tcs/client-portal-api/types/Account';
import Table from '@tcs/client-portal-common/components/molecules/Table';
import BaseHeader from '@tcs/client-portal-common/components/molecules/Table/cells/headers/BaseHeader';
import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import AmountCell from '@tcs/client-portal-common/components/molecules/Table/cells/AmountCell';
import { useStyles } from './style';

interface Props {
  accounts: Account[];
  onRowClick: (account: Account) => void;
}

const AccountsTable = ({ accounts, onRowClick }: Props) => {
  const classes = useStyles(undefined);

  const columns = [
    {
      accessor: 'displayAccountType',
      header: () => <BaseHeader text="Account Type" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 300,
    },
    {
      accessor: 'accountNumber',
      header: () => <BaseHeader text="Account Number" />,
      cell: (info) => <BaseCell value={info.getValue()} />,
      size: 300,
    },
    {
      accessor: 'totalValue',
      header: () => <BaseHeader text="Account Value" align="right" />,
      cell: (info) => <AmountCell value={info.getValue()} />,
      size: 200,
    },
  ];

  if (!accounts.length) {
    return null;
  }

  return (
    <div>
      <Typography
        variant="h5"
        color="textPrimary"
        className={classes.title}
        data-test-id="table-title">
        Accounts and Values
      </Typography>
      <Table data={accounts} columns={columns} onRowClick={onRowClick} />
    </div>
  );
};

export default AccountsTable;
